import React from 'react'

import backgroundImg from '../ui/Backdrop_home.png'
import kampnagel_logo from '../ui/kampnagel_logo.svg'
import evz_logo from '../ui/evz_logo.svg'
import ArAppAd from '../core/ArAppAd'

// import backgroundVideo from '../ui/kaleidoskope_Backdrop_video.mp4'

import './home.css'


const Home = () => {
  return (
    <>



      <div id='backdropContainer'>

      <img src={backgroundImg} alt="Ein Bild mit Kaleidoskopmuster" id='Backdrop' />
      </div>

      


      <div className='page'>


        <div>

          <h1 className='title'>Zwangsarbeit und Widerstand</h1>
          <p className='text'>
            Herzlich Willkommen auf der Webseite des Projektes zur Aufarbeitung der Geländegeschichte Kampnagels während des Nationalsozialismus. Dem Massenphänomen Zwangsarbeit im NS wurde bisher wenig Aufmerksamkeit geschenkt – und auch die Institution Kampnagel hat die eigene Verwicklung in die Verbrechen des NS lange Zeit nicht ausreichend aufgearbeitet. Nach 2-jähriger Recherche veröffentlichen wir hier ein Archiv, das die über 500 Zwangsarbeitenden, die auf Kampnagel tätig waren, auflistet und vorhandene Informationen zu den Individuen sammelt und weiterführende Texte und Links anbietet. Die Webseite lädt darüber hinaus dazu ein, sich vertiefend mit dem Thema zu befassen und die Tour in einem 3D-Rundgang zu erleben.
            <br />
            <br />
            Diese Webseite ergänzt den Augmented-Reality-Rundgang, der in der App angeboten wird. Die App bietet die Möglichkeit, sich vor Ort in die Geschichte(n) der Zwangsarbeitenden einzulassen und ein empathisches Verständnis für die Lebensbedingungen zu entwickeln. Das Gesamtprojekt verbindet historische Recherche mit künstlerischer digitaler Umsetzung, die zu einem verantwortungsvollen Umgang mit NS Unrecht beiträgt.
            <br />
            <br />
          </p>

        </div>




        <hr />



        <div className='section'>
          <div>
            <h1 className='title'>Das Team</h1>

          </div>

          <div className='row'>
            <div className='column'>

              <div className='position'>
                <p className='funktion'>
                  Konzept, Dramaturgie und Redaktion:
                </p>

                <p className='namen'>
                  Sirwan Ali
                </p>

                <p className='namen'>
                  Alina Buchberger
                </p>

                <p className='namen'>
                  Nadine Jessen
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Künstlerisches Rechercheteam, Konzept und Texte:
                </p>

                <p className='namen'>
                  Sophia Hussain
                </p>

                <p className='namen'>
                  Simone Rozalija Thiele
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Forschungsassistent*in:
                </p>

                <p className='namen'>
                  Vivian Hoyer
                </p>

                <p className='namen'>
                  Corinna Saric
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Digitale Umsetzung App:
                </p>

                <p className='namen'>
                  Sirwan Ali
                </p>

                <p className='namen'>
                  Lena Bieresch
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Programmierung App:
                </p>

                <p className='namen'>
                  Sirwan Ali
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  3D-Künstler für App:
                </p>

                <p className='namen'>
                  Tim Mayer
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  3D Experience Design:
                </p>

                <p className='namen'>
                  Lena Bieresch
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Grafikdesign für App, Webseite und Wandzeitung:
                </p>

                <p className='namen'>
                  Soner Kaya
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Übersetzung für Englisch und Polnisch:
                </p>

                <p className='namen'>
                  Daniel Chelminiak
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Übersetzung für Italienisch:
                </p>

                <p className='namen'>
                  Donatella Brioschi
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Übersetzung für Russisch:
                </p>

                <p className='namen'>
                  Nikita Kotliar
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Lektorat für Polnisch:
                </p>

                <p className='namen'>
                  Joanna Ostrowska
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Lektorat für English:
                </p>

                <p className='namen'>
                  Pascal Schmidt
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Stimme des Kaleidoskop:
                </p>

                <p className='namen'>
                  Sophia Hussain
                </p>
              </div>




            </div>




            <div className='column2'>

              <div className='position'>
                <p className='funktion'>
                  Stimme des Researcher-Avatars:
                </p>

                <p className='namen'>
                  Simone Rozalija Thiele
                </p>
              </div>

              <div className='position'>
                <p className='funktion'>
                  Stimme der Originalzitate:
                </p>

                <p className='namen'>
                  Aaron Aydin
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Info-Stimme:
                </p>

                <p className='namen'>
                  Viktoria Gur´Eva
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Stimme der Handlungsoptionen:
                </p>

                <p className='namen'>
                  Claudiu Mark Draghici
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Stimme des Techniker-Avatars:

                </p>

                <p className='namen'>
                  Jörn Walter
                </p>
              </div>










              <div className='position'>
                <p className='funktion'>
                  Stimme des Finanzverwaltungs-Avatars:

                </p>

                <p className='namen'>
                  Patricia Arlt
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Stimme der Postkarte:

                </p>

                <p className='namen'>
                  Valentina Schüler
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Stimme des Glückwunsch-Avatars:

                </p>

                <p className='namen'>
                  Siri Keil
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Audio Wandzeitung:

                </p>

                <p className='namen'>
                  Valentina Schüler
                </p>
              </div>


















              <div className='position'>
                <p className='funktion'>
                  Englische Stimme der App:

                </p>

                <p className='namen'>
                  Daniel Chelminiak
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Sprachaufnahmen:

                </p>

                <p className='namen'>
                  René Huthwelker
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Stellvertretende Leitung Öffentlichkeitsarbeit:

                </p>

                <p className='namen'>
                  Siri Keil
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Projekt- & Finanzierungsmanagement:

                </p>

                <p className='namen'>
                  René Janiszewski
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Produktionsmanagement:

                </p>

                <p className='namen'>
                  Junior Barros  </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Leitung Künstlerisches Betriebsbüro:

                </p>

                <p className='namen'>
                  Lea Connert
                </p>
              </div>


              <div className='position'>
                <p className='funktion'>
                  Besonderen Dank an:

                </p>

                <p className='namen'>
                  Carina Book
                </p>
              </div>

            </div>
          </div>
        </div>








        <div className='funders'>
          <p className='home_title'>
            Partner & Förderer
          </p>


          <div className='container'>
            <div className='funders_logo_background'>

              <img src={kampnagel_logo} alt="logo von Kampnagel" />
              <img src={evz_logo} alt="logo von evz" />

            </div>

          </div>




        </div>


        






      </div>

      <ArAppAd />



    </>
  )
}

export default Home